import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CoreModule } from './../core/core.module';
import { TrialGuardService } from '../core';
import {
  SalesRepBaseComponent,
  SalesRepComponent,
  SalesRepsComponent,
  SalesRepCustomersComponent,
  SalesRepDashboardComponent,
  SalesRepProductTypesComponent,
  SalesRepService,
  SelectedSalesRepService,
  SalesRepCustomerService,
} from '../sales-rep';
import { CollapsibleComponent } from '@/app/equipment/components/collapsible.component';
import { CollapsibleButtonComponent } from '@/app/equipment/components/collapsible-button.component';
import { CollapsedCardsDirective } from '@/app/equipment/components/collapsed-cards.directive';
import {
  EquipmentService,
  ProductTypeTransactionsComponent,
} from '../equipment';
import { SavedViewsModule } from '@/app/modules/saved-views/saved-views.module';
import { SavedViewsComponent } from '@/app/modules/saved-views/saved-views/saved-views.component';
import { LogService } from '@/app/core/services/log.service';
import { FeatureFlagModule } from '@/app/core/feature-flags/feature-flag.module';

const root = 'sales-reps';
const salesRepRoutes: Routes = [
  {
    path: root,
    component: SalesRepsComponent,
    data: { title: 'main.tabs.sales_reps.page_titles.root' },
    canActivate: [TrialGuardService],
  },
  {
    path: root + '/:salesRep',
    component: SalesRepComponent,
    canActivate: [TrialGuardService],
    children: [
      {
        path: '',
        component: SalesRepDashboardComponent,
        data: {
          name: 'dashboard',
          title: 'main.tabs.sales_reps.page_titles.dashboard',
        },
      },
      {
        path: 'customers',
        component: SalesRepCustomersComponent,
        data: {
          name: 'customers',
          title: 'main.tabs.sales_reps.page_titles.customers',
        },
      },
      {
        path: 'product-types',
        component: SalesRepProductTypesComponent,
        data: {
          name: 'product-types',
          title: 'main.tabs.sales_reps.page_titles.product_types',
        },
      },
      {
        path: 'transactions',
        component: ProductTypeTransactionsComponent,
        data: { title: 'main.tabs.sales_reps.page_titles.transactions' },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(salesRepRoutes),
    CommonModule,
    CoreModule,
    InfiniteScrollModule,
    SavedViewsModule,
    SavedViewsComponent,
    CollapsibleComponent,
    CollapsibleButtonComponent,
    CollapsedCardsDirective,
    FeatureFlagModule,
  ],
  declarations: [
    SalesRepBaseComponent,
    SalesRepComponent,
    SalesRepsComponent,
    SalesRepDashboardComponent,
    SalesRepCustomersComponent,
    SalesRepProductTypesComponent,
  ],
  providers: [
    SalesRepService,
    SalesRepCustomerService,
    SelectedSalesRepService,
    EquipmentService,
    TrialGuardService,
    LogService,
  ],
})
export class SalesRepModule {}
